module.exports = __webpack_public_path__ + "static/media/testimonial-4.9e7d125e.jpg";